import {
    temAcesso
} from '@/shared/auth/temAcesso'

const AtualizacoesCadastrais = () => import('./AtualizacoesCadastrais.vue')
const AtualizacaoCadastralDetalhar = () => import('./AtualizacaoCadastralDetalhar.vue')

export default {
    path: 'atualizacoescadastrais',
    name: 'GestaoAtualizacoesCadastrais',
    component: AtualizacoesCadastrais,
    beforeEnter: (to, from, next) => {
        if (temAcesso('GEST-DADOS-00')) {
            next()
        }
    },
    children: [{
        path: ':atualizacaoCadastralId',
        name: 'GestaoAtualizacoesCadastrais_Detalhar',
        component: AtualizacaoCadastralDetalhar,
        beforeEnter: (to, from, next) => {
            if (temAcesso('GEST-DADOS-00')) {
                next()
            }
        }
    }]
}
